<script>
export default {
  props: {
    text: String,
  },
};
</script>

<template lang='pug'>
.text-white.border-b-3.border-white.p-_5.cursor-pointer.transition-250.transition-all.text-2xl.md_text-base.hover_text-gray-300.hover_border-gray-300.active_border-gray-300.visited_border-white(
  tabindex='0',
  @click='$emit("click", $event)',
  @keyup.enter='$emit("click", $event)',
) {{text}}
</template>

<style>
@import '~import/index';

</style>